export enum LoggingLevel {
  All = 0,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4,
  Off = 5,
}
